import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-brand-onboard",
  "use": "icon-soc-l1-brand-onboard-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-brand-onboard\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M512 160l288 528H224L512 160zm0 144L336 608h352L512 304z\" />\r\n  <path d=\"M448 672h128v128H448V672z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-brand-onboard.svg
// module id = 4ZJ6
// module chunks = 491